import { apiServer } from "../config/config";
import { SyncBusinessRespose } from "../types";
import { fetchWithToken } from "./fetchWithToken";
import { NearbyBusinessesResponse } from "../types/nearby-businesses";

export async function fetchBusinessTypes() {
  return await fetch(apiServer + "/business/load-business-types");
}

export async function fetchBusinessTypesFrontend() {
  return await fetch(apiServer + "/business/load-business-types-frontend");
}

export async function addMapperNotes(
  venueId: string,
  notes: string,
  businessReportIssueAction: string,
  token: string,
  noteAreaType: string,
  noteAreaId?: string,
  returnOnDate?: string,
  actionOnDate?: string
) {
  try {
    const formData = new FormData();
    formData.append("business_id", venueId);
    formData.append("notes", notes);

    if (noteAreaId) {
      formData.append("location_details[0][location_type]", noteAreaType);
      formData.append("location_details[0][location_id]", noteAreaId);
    }
    formData.append("businessReportIssueAction", businessReportIssueAction);
    if (returnOnDate) {
      formData.append("return_on_date", returnOnDate);
    }
    if (actionOnDate) {
      formData.append("action_on_date", actionOnDate);
    }
    console.log(formData);
    const response = await fetch(`${apiServer + "/review/report-venue"}`, {
      method: "POST",
      headers: {
        Authorization: "Bearer " + token,
      },
      body: formData,
    });
    const data = await response.json();
    console.log(data);
    if (data.status === "error") {
      return data.message;
    } else {
      return data.data;
    }
  } catch (error: any) {
    return error.message;
  }
}

export async function closeMapperNote(issueId: string, accessToken: string) {
  try {
    const formData = new FormData();
    formData.append("issueId", issueId);
    const response = await fetch(
      `${apiServer + "/business/close-mapper-note"}`,
      {
        method: "POST",
        headers: {
          Authorization: "Bearer " + accessToken,
        },
        body: formData,
      }
    );
    const data = await response.json();
    if (data.status === "error") {
      return data.message;
    } else {
      return data;
    }
  } catch (error: any) {
    console.log(`closeMapperNote error: ${error}`);
    return error.message;
  }
}

export async function syncBusiness(businessId: string, accessToken: string) {
  const formData = new FormData();
  formData.append("business_id", businessId);
  const response = await fetchWithToken(apiServer + "/business/sync-business", {
    method: "POST",
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
    body: formData,
  });
  const data = await response?.json();
  if (data.status === "error") {
    throw new Error(data.message);
  }
  return data as {
    status: string;
    message: string;
    data: SyncBusinessRespose;
  };
}

export async function fetchNearbyBusinesses(businessId: string): Promise<NearbyBusinessesResponse> {
  const formData = new FormData();
  formData.append("business_id", businessId);

  const response = await fetch(`${apiServer}/business/near-by-businesses-details`, {
    method: "POST",
    body: formData,
  });

  const data = await response.json();
  if (data.status === "error") {
    throw new Error(data.message);
  }
  return data;
}
